import { Typography } from "@joonapp/web-shared"

import ManagePasscodeSection from "./ManagePasscodeSection"
import ParentProfileSection from "./ParentProfileSection"
import ChildAuthCode2 from "../../../components/childAuthCode/ChildAuthCode2"
import { useUserQuery } from "../../../networking/queries"
import CoinStatementSection from "../coinTransactions/CoinStatementSection"
import EditProfileModal from "../EditProfileModal"
import useFamilyUserSelectStore from "../hooks/useFamilyUserSelect"

const GeneralTab = () => {
  const { user } = useUserQuery()
  const { selectedUserId } = useFamilyUserSelectStore()
  const isCurrentUser = selectedUserId === user?.id

  return (
    <div className="flex flex-col gap-6 pt-4">
      {isCurrentUser && <ChildAuthCode2 />}
      <ParentProfileSection />
      <CoinStatementSection />
      <div className="flex flex-col gap-2">
        <Typography variant="bodyBold">Access & security</Typography>
        <ManagePasscodeSection />
      </div>
      <EditProfileModal />
    </div>
  )
}

export default GeneralTab
